import script from "./NoticiaLista.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticiaLista.vue?vue&type=script&setup=true&lang=js"

import "./NoticiaLista.vue?vue&type=style&index=0&id=7af30f27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7af30f27"]])

export default __exports__